import { IUser, UserStatus } from '~/interfaces/userInterfaces'
import { ArrayHelper } from '~/helpers/arrayHelper'

export default class UserDefinition {
  static email(...sources: Pick<IUser, 'email'>[]): string {
    const emailSource = ArrayHelper.find(sources, source => Boolean(source?.email))
    return emailSource?.email
  }

  static fullName(user, email: boolean = true): string {
    if (user.full_name) {
      return user.full_name
    } else if (user.name) {
      return user.name
    } else if (user.first_name || user.last_name) {
      return `${user.first_name} ${user.last_name}`
    } else if (email && user.email) {
      return user.email.match(/.+?(?=@)/)
    }
  }

  static statusColorClass(status: UserStatus): string {
    switch (status) {
      case 'Active':
        return 'text-green'
      case 'Deactivated':
        return 'text-maroon'
      case 'Pending':
        return 'text-fuchsia'
      case 'Expired':
        return 'text-gray'
      default:
        return ''
    }
  }

  static statusBackgroundColorClass(status: UserStatus): string {
    switch (status) {
      case 'Active':
        return 'bg-light-green'
      case 'Deactivated':
        return 'bg-light-red'
      case 'Pending':
        return 'bg-light-fuchsia'
      case 'Expired':
        return 'bg-light-gray'
      default:
        return ''
    }
  }
}